import { render, staticRenderFns } from "./CategoryQuizLayout.vue?vue&type=template&id=f3e4ac10&scoped=true"
import script from "./CategoryQuizLayout.vue?vue&type=script&lang=js"
export * from "./CategoryQuizLayout.vue?vue&type=script&lang=js"
import style0 from "./CategoryQuizLayout.vue?vue&type=style&index=0&id=f3e4ac10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e4ac10",
  null
  
)

export default component.exports